export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/decor-left.f94c91c6-adfd4e.png";